import { FC, useCallback } from "react";
import "./StatisticsUsage.scss";
import { UsageStatDTO } from "../../../openapi/requests";
import{ Progress } from "antd";

export interface StatisticsUsageProps {
    items: UsageStatDTO[],
    label: string,
    showLimit: boolean
}

const StatisticsUsage: FC<StatisticsUsageProps> = ({items, label, showLimit}) => {

    const calculatePercent = (item:UsageStatDTO) => {
        return Math.round((item.currentUsage/item.usageLimit)*100);
    }

    const usageCalculation = useCallback((item: UsageStatDTO) => {
        return (showLimit) ? `${item.currentUsage.toLocaleString('en-GB', { minimumFractionDigits: 0 })}/${item.usageLimit.toLocaleString('en-GB', { minimumFractionDigits: 0 })}` : `${item.currentUsage.toLocaleString('en-GB', { minimumFractionDigits: 0 })}`
    }, [showLimit])

    return (
        <div className="statistics-usage">
             <h2>{label}</h2>
            {items.map(item => 
                <div key={item.name} className="statistics-usage-item">
                    <span>{item.name}</span>
                    <span>{usageCalculation(item)}</span>
                    <Progress percent={calculatePercent(item)} strokeLinecap="square" showInfo={(calculatePercent(item) > 100)}   percentPosition={{ align: 'center', type: 'inner' }} format={(percent) => "Limit reached"} strokeColor={(calculatePercent(item) < 100) ?"rgb(114, 114, 114)" : "rgb(0,0,0)"} size={{height: 30}} />
                </div>        
            )}
        </div>
    )
}

export default StatisticsUsage;